import AdminStaffPage from '../../../components/admin/admin-staff/AdminStaffPage'

export default function AdminStaff() {
  return <AdminStaffPage />
}
